/** @module Archiving/Archiving.ArchiveReportController */
define([
    "dojo/_base/declare",
    "csi/action/Controller",
    "csi/comm"
], function(declare,ActionController,comm) {

    return declare(ActionController, {
        
        /**
         * @override
         * if the query accelerator is being used, it may not have the new nodes yet, so disable it temporarily
         */
        postProcessSuccess: function() {
            comm.bypassQueryAccelerator();
            return this.inherited(arguments);
        }
 
    });
});